import React from "react";
import {
  UserPlus, UserCog, UserMinus,
  FilePlus, FileEdit, Trash2,
  CreditCard, Ban, Settings as SettingsIcon,
  KeyRound, RotateCcw, MessageSquareHeart,
  Activity,
} from "lucide-react";

const ACTION_META = {
  create: { label: "créé", tint: "text-[#065F46] bg-[#D1FAE5]" },
  update: { label: "modifié", tint: "text-[#1E40AF] bg-[#DBEAFE]" },
  delete: { label: "supprimé", tint: "text-[#991B1B] bg-[#FEE2E2]" },
  revoke: { label: "révoqué", tint: "text-[#991B1B] bg-[#FEE2E2]" },
  change_password: { label: "a changé son mot de passe", tint: "text-[#6B21A8] bg-[#F3E8FF]" },
  reset_password: { label: "a réinitialisé le mot de passe", tint: "text-[#6B21A8] bg-[#F3E8FF]" },
};

const ENTITY_META = {
  agent: { label: "utilisateur", icon: UserCog, createIcon: UserPlus, deleteIcon: UserMinus },
  document: { label: "document", icon: FileEdit, createIcon: FilePlus, deleteIcon: Trash2 },
  feedback: { label: "feedback", icon: MessageSquareHeart, createIcon: MessageSquareHeart, deleteIcon: Trash2 },
  subscription: { label: "abonnement", icon: CreditCard, createIcon: CreditCard, deleteIcon: Ban },
  settings: { label: "paramètres", icon: SettingsIcon, createIcon: SettingsIcon, deleteIcon: SettingsIcon },
  account: { label: "compte", icon: KeyRound, createIcon: KeyRound, deleteIcon: KeyRound },
};

export default function AuditEntryRow({ entry }) {
  const a = ACTION_META[entry.action] || { label: entry.action, tint: "text-foreground/70 bg-foreground/5" };
  const e = ENTITY_META[entry.entity_type] || { label: entry.entity_type, icon: Activity, createIcon: Activity, deleteIcon: Activity };
  const Icon =
    entry.action === "create" ? (e.createIcon || e.icon) :
    entry.action === "delete" || entry.action === "revoke" ? (e.deleteIcon || e.icon) :
    entry.action === "reset_password" ? RotateCcw :
    e.icon;

  const details = entry.details || {};
  const detailFragments = [];
  if (details.fields && details.fields.length) {
    detailFragments.push(`champs: ${details.fields.join(", ")}`);
  }
  if (details.role) detailFragments.push(`rôle → ${details.role}`);
  if (details.plan) detailFragments.push(`${details.plan}/${details.billing || "?"}`);
  if (details.amount_xaf) detailFragments.push(`${Number(details.amount_xaf).toLocaleString("fr-FR")} XAF`);
  if (details.chunks) detailFragments.push(`${details.chunks} chunks`);
  if (details.note) detailFragments.push(`note: ${details.note}`);

  return (
    <li className="px-5 py-3 border-b border-primary/5 last:border-none hover:bg-primary/5 transition-colors" data-testid={`audit-row-${entry.id}`}>
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 shrink-0 bg-primary/10 text-primary rounded-sm flex items-center justify-center mt-0.5">
          <Icon size={14} strokeWidth={1.8} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm text-foreground/85 leading-snug">
            <span className="font-medium text-primary">{entry.actor_email}</span>
            {" "}
            <span className={`font-mono text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded-sm ${a.tint}`}>
              {a.label}
            </span>
            {" "}<span className="text-foreground/60">{e.label}</span>
            {entry.entity_label && (
              <>
                {" — "}
                <span className="font-mono text-xs text-foreground/80">{entry.entity_label}</span>
              </>
            )}
          </div>
          {detailFragments.length > 0 && (
            <div className="mt-1 font-mono text-[10px] text-foreground/50 truncate">
              {detailFragments.join(" · ")}
            </div>
          )}
        </div>
        <span className="font-mono text-[10px] text-foreground/40 shrink-0">
          {entry.created_at ? new Date(entry.created_at).toLocaleString() : ""}
        </span>
      </div>
    </li>
  );
}
